import { IPowerbarStoreModule, registerAdapter, unregisterAdapter } from '../utils';
import { IFundHistoryState } from './types';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import state from './state';

const FundHistoryState: IPowerbarStoreModule<IFundHistoryState, any> = {
  name: 'FundHistoryState',
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
FundHistoryState.register = registerAdapter(FundHistoryState);
FundHistoryState.unregister = unregisterAdapter(FundHistoryState);

export default FundHistoryState;
